import { BackendResponseModel, ErrorCodes, RawErrorItem } from '../../models';
import { BaseErrorHandler } from './base-error.handler';

export class MwInternetOfflineErrorHandler extends BaseErrorHandler {
  handle(): BackendResponseModel {
    const error = this.getError();
    const result = new BackendResponseModel();

    if (error) {
      result.addError({
        errorCode: error.errorCode,
        errorDescription: error.message,
        errorDetails: '',
        memberName: '',
      });
    }

    return result;
  }

  canHandle(): boolean {
    return !!this.getError();
  }

  private getError(): RawErrorItem | undefined {
    return this.httpResponseError?.errors?.find(
      (t) => [ErrorCodes.Offline].indexOf(t.errorCode) !== -1
    );
  }
}
